module.exports = __webpack_public_path__ + "img/partner8.d0f077ae.png";